 <div class="casePnlBox">
      <div class="case-header">
        <h3><img src="../../../../assets/cocoonImages/computer-icon.svg" alt="Case Backup"> Screenstream</h3>
        <div class="caseScreen">
          <ul>
            <li><img src="../../../../assets/cocoonImages/calendar-icon.svg" alt="View Icon"> 10 March, 2025</li>
            <li>08:23pm</li>
            <!-- <li><a href="#" onclick="return false;" class="view-details"><img src="../../../../assets/cocoonImages/view-icon.svg"
                  alt="View Icon"></a></li> -->
          </ul>
        </div>
      </div>
      <div class="case-content" >
        <img src="../../../../assets/cocoonImages/image@2x.jpg" alt="Main Image" class="maxWidth" />
      </div>
    </div>